import { useQuery, UseQueryOptions } from 'react-query';
import {
  getAllSolutionProducts,
  getAllProducts,
  getLedgerSystems,
  getProductById,
} from '~/api/product';
import { Product } from '~/types';

export const useProductById = (productId?: string, options?: UseQueryOptions<Product>) => {
  return useQuery<Product>(
    ['productById', productId],
    () => getProductById(productId!).then((res) => res.data),
    {
      enabled: !!productId,
      ...options,
    }
  );
};

export const useProductsBySolutionId = (solutionId?: string) => {
  return useQuery(['solutionProducts', solutionId], () => getAllSolutionProducts(solutionId!), {
    enabled: !!solutionId,
  });
};

export const useGetAllProducts = () => {
  return useQuery(['products'], () => getAllProducts());
};

export const useGetLedgerSystems = () => {
  return useQuery(['ledgerSystems'], () => getLedgerSystems());
};
